var path = '/templates/projects.segments/show.html';
var html = "<zc-campaign-segment-show segment-id=segment.id project=project></zc-campaign-segment-show>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.segments/show.html
// module id = 1500
// module chunks = 0